



















































































import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Checkbox, CheckboxGroup, Button, Field, Popup, Area } from "vant";
import CustomUploader from "@/components/CustomUploader.vue";

const createAccountModule = namespace("createAccount");
const failReasonModule = namespace("failReason");

@Component({
  name: 'W8BEN',
  components: {
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Button.name]: Button,
    [Field.name]: Field,
    [Popup.name]: Popup,
    [Area.name]: Area,
    customUploader: CustomUploader
  }
})
export default class W8BEN extends Vue {
  @createAccountModule.Getter("id_card_ocr_info") id_card_ocr_info: any;
  @createAccountModule.Getter("address_proof_info") address_proof_info: any;
  @createAccountModule.Getter("open_mode_info") open_mode_info: any;
  @createAccountModule.Getter("w8ben_info") w8ben_info: any;
  @failReasonModule.Mutation("SAVE_MODIFIED_FAIL_REASON")
  saveModifiedFailReason: any;

  form = {
    tax_name: "",
    contain_area: "",
    province_name: "",
    province_code: "",
    city_code: "",
    city_name: "",
    country_name: "",
    country_code: "",
    detail_address: ""
  };

  showAddressPicker = false;
  areaList = {};
  isLoadingAddress = true;

  @Watch("w8ben_info", { deep: true, immediate: true })
  watchW8benInfo(val) {
    // const { modify } = this.$route.query;
    // if (!modify) return;
    this.form = {
      ...this.form,
      ...val
    };
  }

  @Watch("id_card_ocr_info", { deep: true, immediate: true })
  watchIdCardOcrInfo(val) {
    const { english_name } = val;
    this.form.tax_name = english_name;
  }
  get bgColor() {
    return this.$store.getters["common/bgColor"];
  }

  get addressText() {
    if (this.form.province_name) {
      return [
        this.form.province_name,
        this.form.city_name,
        this.form.country_name
      ]
        .filter(item => {
          return item !== "";
        })
        .join(" ");
    } else {
      return "";
    }
  }

  get isSubmitDisabled() {
    return !(this.addressText && this.form.detail_address);
  }

  get isModify() {
    return this.$route.query.modify == "1";
  }

  created() {
    this.form.contain_area =
      this.open_mode_info.open_status == 2 ? "Hong Kong" : "China";
  }

  handleOpenAddressPicker() {
    if (Object.keys(this.areaList).length !== 0) {
      return;
    }
    //获得省市区json
    (this as any).$apis
      .getAddressLists({
        type: "en"
      })
      .then(res => {
        this.isLoadingAddress = false;
        this.areaList = res;
      })
      .catch(e => {
        
      });
  }

  handleSetAddress(arr) {
    
    this.form.province_name = arr[0] ? arr[0].name : "";
    this.form.province_code = arr[0] ? arr[0].code : "";
    this.form.city_name = arr[1] ? arr[1].name : "";
    this.form.city_code = arr[1] ? arr[1].code : "";
    this.form.country_name = arr[2] ? arr[2].name : "";
    this.form.country_code = arr[2] ? arr[2].code : "";

    this.showAddressPicker = false;
  }

  handleSaveW8BEN() {
    (this as any).$apis
      .save8BinInfo({
        w_ben_content: this.form
      })
      .then(() => {
        const { modify, from } = this.$route.query;
        if (modify == "1") {
          if (from == "address_proof") {
            this.saveModifiedFailReason(3);
            this.$router.go(-2);
          } else {
            this.saveModifiedFailReason(5);
            this.$router.go(-1);
          }
        } else {
          this.$router.push("/survey/page-one");
        }
      })
      .catch(e => {
        
      });
  }
}
